import React from "react";
import {connect} from "react-redux";
import {Heading, Text} from "components/styled";
import styled from "styled-components";
import {glossaryLocalization} from "localization";
import ScrollArea from "react-scrollbar";

const Glossary = ({selectedLanguage}) => {
    const {
        title,
        titleText1,
        text1,
        titleText2,
        text2,
        titleText3,
        text3,
        titleText4,
        text4,
        titleText5,
        text5,
        titleText6,
        text6,
        titleText7,
        text7,
        titleText8,
        text8,
        titleText9,
        text9,
        titleText10,
        text10,
        titleText11,
        text11,
        titleText12,
        text12,
        titleText13,
        text13
    } = glossaryLocalization[selectedLanguage];
    return (
        <PopupContent lang={selectedLanguage}>
            <ScrollArea className="options" smoothScrolling minScrollSize={30}>
                <div className="main-title">{title}</div>
                <Content>
                    <Heading.h2>{titleText1}</Heading.h2>
                    <Text>{text1}</Text>
                    <Heading.h2>{titleText2}</Heading.h2>
                    <Text>{text2}</Text>
                    <Heading.h2>{titleText3}</Heading.h2>
                    <Text>{text3}</Text>
                    <Heading.h2>{titleText4}</Heading.h2>
                    <Text>{text4}</Text>
                    <Heading.h2>{titleText5}</Heading.h2>
                    <Text>{text5}</Text>
                    <Heading.h2>{titleText6}</Heading.h2>
                    <Text>{text6}</Text>
                    <Heading.h2>{titleText7}</Heading.h2>
                    <Text>{text7}</Text>
                    <Heading.h2>{titleText8}</Heading.h2>
                    <Text>{text8}</Text>
                    <Heading.h2>{titleText9}</Heading.h2>
                    <Text>{text9}</Text>
                    <Heading.h2>{titleText10}</Heading.h2>
                    <Text>{text10}</Text>
                    <Heading.h2>{titleText11}</Heading.h2>
                    <Text>{text11}</Text>
                    <Heading.h2>{titleText12}</Heading.h2>
                    <Text>{text12}</Text>
                    <Heading.h2>{titleText13}</Heading.h2>
                    <Text>{text13}</Text>
                </Content>
            </ScrollArea>
        </PopupContent>
    );
};

const PopupContent = styled.div`
  div {
    font-family: ${props =>
    props.lang === "en"
        ? '"Work Sans", sans-serif'
        : '"Noto Sans", sans-serif'};
  }
`;

const Content = styled.div`
  margin-top: 40px;
  margin-right: 40px;
  h2 {
    font-size: ${props => (props.lang === "en" ? "18px" : "20px")};
    margin-bottom: 4px;
  }
  p {
   color: var(--color-theme);
   opacity: .7;
    font-size: ${props => (props.lang === "en" ? "14px" : "16px")};
    line-height: 1.5;
    & + h2 {
      margin-top: 40px;
    }
  }
`;

export default connect(state => ({
    selectedLanguage: state.localizationReducers.selectedLanguage
}))(Glossary);



// WEBPACK FOOTER //
// ./src/pages/glossary/glossary.js